import { create } from 'zustand'

interface App {
  id: string
  package_name: string
  name?: string
}

interface PackageStore {
  selectedApp: App | null
  appList: App[]
  setSelectedApp: (app: App | null) => void
  setAppList: (apps: App[]) => void
  clearSelectedApp: () => void
}

export const usePackageStore = create<PackageStore>()((set) => ({
  selectedApp: null,
  appList: [],
  setSelectedApp: (app) => set({ selectedApp: app }),
  setAppList: (apps) => set({ appList: apps }),
  clearSelectedApp: () => set({ selectedApp: null }),
}))

// Alias for backward compatibility
export const useAppStore = usePackageStore
